import { EmbeddedBlock } from '@tinct/core-api-models';

/**
 * Personalization is enabled by default for every block type (customer_logo
 * included), so only an explicit `false` counts as disabled — `null` (a block
 * predating the flag, or a ref-only projection) is enabled.
 *
 * The flag is preview/publish-side only: variants exist for every block
 * regardless, the studio just filters which ones it applies, and the live page
 * picks the change up on the next publish.
 */
export const isBlockPersonalizationEnabled = (
  block: Pick<EmbeddedBlock, 'enabled'>,
): boolean => block.enabled !== false;
